// src/pages/Profile/InitialProfile.tsx
import React from 'react'
import ProfileSection from '../../components/common/ProfileSection/ProfileSection'
import { useFetchUserDetails } from './api'
import { ROLE_DISPLAY_NAME } from '../Login/api'

const InitialProfile: React.FC = () => {
  const { data, isLoading, isError } = useFetchUserDetails()

  if (isLoading) return <p>Loading...</p>
  if (isError) return <p>Error loading user details</p>

  const user = data?.user

  const getInitials = (fullName: string | undefined): string => {
    if (!fullName) return 'N/A'
    const parts = fullName.trim().split(' ')
    if (parts.length === 1) return parts[0][0].toUpperCase()
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
  }

  const formatName = (fullName: string | undefined): string => {
    if (!fullName) return 'N/A'
    return fullName
      .trim()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  }

  const initials = getInitials(user?.name)
  const displayName = formatName(user?.name)

  return (
    <div>
      <ProfileSection
        name={displayName}
        role={
          ROLE_DISPLAY_NAME[user?.role as keyof typeof ROLE_DISPLAY_NAME] ||
          'Unknown Role'
        }
        // status={user?.status === 0 ? "Active" : "Inactive"}
        profilePic={user?.profilePic || ''}
        initials={initials}
      />
    </div>
  )
}

export default InitialProfile
